export function obtenerParametrosConsultaArticulos(newCoReposiciones, subtiposArticulo) {
  const {
    filters: {
      pagination: { page, pageSize }, tienda, proveedor, tipoArticulo, propiedades, searchText, rangoFechas,
    },
  } = newCoReposiciones;
  const subtipos = subtiposArticulo.filter(e => e.tipo.id === tipoArticulo);
  const obtenerPropiedadSubtipo = (propiedades, subtipo) => (subtipo && propiedades[subtipo.nombre] !== -1 ? { valor: propiedades[subtipo.nombre] } : undefined);
  const filtrosPropiedades = {
    codigoPropiedad1: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 1)),
    codigoPropiedad2: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 2)),
    codigoPropiedad3: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 3)),
    codigoPropiedad4: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 4)),
    codigoPropiedad5: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 5)),
    codigoPropiedad6: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 6)),
    codigoPropiedad7: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 7)),
    codigoPropiedad8: obtenerPropiedadSubtipo(propiedades, subtipos.find(e => e.subtipo === 8)),
  };
  const filtros = {
    tienda: { valor: tienda },
    codigoProveedor: { valor: proveedor },
    ...filtrosPropiedades,
  };
  if (tipoArticulo !== -1) {
    filtros.tipo = { valor: tipoArticulo };
  }
  if (searchText && searchText !== '') {
    filtros.descripcion = { valor: `%${searchText}%`, operador: 'like' };
  }
  if (rangoFechas) {
    filtros.date_ini = { valor: rangoFechas?.date_ini.format('YYYY-MM-DD'), operador: 'eq' };
    filtros.date_fin = { valor: rangoFechas?.date_fin.format('YYYY-MM-DD'), operador: 'eq' };
  }
  const formData = new FormData();
  formData.append('pagina', page - 1);
  formData.append('limite', pageSize);
  formData.append('orden', JSON.stringify({ id: 'DESC' }));
  formData.append('consulta', JSON.stringify(filtros));

  return formData;
}
